
// import Chart from 'react-apexcharts';

// const BarGraph = ({ data }) => {
// const serviceAmounts = data.series.map((item) =>
//     parseFloat((item.serviceAmount ?? 0).toFixed(2)),
//   );
//   const productAmounts = data.series.map((item) =>
//     parseFloat((item.productAmount ?? 0).toFixed(2)),
//   );

//   let graphObject = {
//     options: {
//       chart: {
//         id: 'basic-bar',
//       },
//       xaxis: {
//         categories: data?.categories, // Assuming 'categories' is provided in the data prop
//       },
//       title: {
//         text: 'As per Service and Product',
//         align: 'center',
//         style: {
//           fontSize: '14px',
//           fontWeight: 'bold',
//           color: 'green',
//         },
//       },
//       plotOptions: {
//         bar: {
//           horizontal: false,
//         },
//       },
//       colors: ['#008FFB', '#FFB6C1'], // Blue for Service, Light Pink for Product
//       dataLabels: {
//         enabled: true, // Show the data values on the bars
//         formatter: function (val) {
//           return val === 0 ? '0' : val; // Ensure 0 is displayed as 0
//         },
//         offsetY: -20,
//         style: {
//           fontSize: '12px',
//           colors: ['black'], // Data label color
//         },
//       },
//       tooltip: {
//         y: {
//           formatter: function (val) {
//             return val === 0 ? '0' : val; // Ensure tooltip shows 0 correctly
//           },
//         },
//       },
//     },
//     series: [
//       {
//         name: 'Service',
//         data: serviceAmounts, // Blue bars for Service
//       },
//       {
//         name: 'Product',
//         data: productAmounts, // Light Pink bars for Product
//       },
//     ],
//   };

//   return (
//     <div>
//       <Chart
//         options={graphObject.options}
//         series={graphObject.series}
//         type="bar"
//         width="650"
//       />
//     </div>
//   );
// };

// export default BarGraph;








import React from 'react';
import { Card, CardContent, Typography, Box, Grid, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FaUserTie, FaCut, FaBoxOpen } from "react-icons/fa";

function stringToColor(string) {
  if (!string) {
    return '#000000';
  }
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

const StaffCard = ({ staff }) => {
    const serviceAmount = staff.serviceAmount || 0;
    const productAmount = staff.productAmount || 0;

    return (
        <Card 
            sx={{ 
                borderRadius: 3, 
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)', 
                height: '100%',
                border: '1px solid rgba(0, 0, 0, 0.08)',
            }}
        >
            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                <Box sx={{ 
                    p: 1.5, 
                    background: '#f1f5f9',
                    display: 'flex', 
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(0,0,0,0.05)'
                }}>
                    <Avatar sx={{ 
                        bgcolor: stringToColor(staff.staffName), 
                        mr: 1.5,
                        width: 40,
                        height: 40,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                        {staff.staffName?.charAt(0).toUpperCase()}
                    </Avatar>
                    <Box>
                        <Typography variant="subtitle1" fontWeight="700" sx={{ lineHeight: 1.2 }}>
                            {staff.staffName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                           <FaUserTie size={10} /> Staff Member
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ p: 1.5 }}>
                    <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                            <Box sx={{ p: 1, borderRadius: 2, bgcolor: '#eef2ff', color: '#4f46e5' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5, opacity: 0.8 }}>
                                    <FaCut size={10} />
                                    <Typography variant="caption" fontWeight="700" textTransform="uppercase" fontSize="0.7rem">Service</Typography>
                                </Box>
                                <Typography variant="subtitle1" fontWeight="800">
                                    ₹{Number(serviceAmount).toLocaleString("en-IN")}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{ p: 1, borderRadius: 2, bgcolor: '#fffbeb', color: '#b45309' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5, opacity: 0.8 }}>
                                    <FaBoxOpen size={10} />
                                    <Typography variant="caption" fontWeight="700" textTransform="uppercase" fontSize="0.7rem">Product</Typography>
                                </Box>
                                <Typography variant="subtitle1" fontWeight="800">
                                    ₹{Number(productAmount).toLocaleString("en-IN")}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    );
};

const BarGraph = ({ data }) => {
  const staffNames = data?.categories || [];
  const staffSalesData = data?.series || [];

  const staffList = staffNames.map((name, index) => ({
    staffName: name,
    ...staffSalesData[index],
  }));

  if (!staffList || staffList.length === 0) {
    return (
        <Card>
            <CardContent>
                <Typography>No staff collection data for this period.</Typography>
            </CardContent>
        </Card>
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
        <Grid container spacing={2}>
            {staffList.map((staff) => (
                <Grid item xs={12} sm={6} md={3} key={staff.staffId || staff.staffName}>
                    <StaffCard staff={staff} />
                </Grid>
            ))}
        </Grid>
    </Box>
  );
};

export default BarGraph;
